/**
 * @generated SignedSource<<6bcfa60af6d97c7269164adc787af3fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSavedPromptInput = {
  name: string;
  promptText: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateSavedPromptMutation_Mutation$variables = {
  input: CreateSavedPromptInput;
};
export type CreateSavedPromptMutation_Mutation$data = {
  readonly createSavedPrompt: {
    readonly savedPrompt: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly promptText: string | null;
        readonly createdAt: string | null;
      } | null;
    } | null;
  } | null;
};
export type CreateSavedPromptMutation_Mutation = {
  variables: CreateSavedPromptMutation_Mutation$variables;
  response: CreateSavedPromptMutation_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSavedPromptPayload",
    "kind": "LinkedField",
    "name": "createSavedPrompt",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SavedPromptTypeEdge",
        "kind": "LinkedField",
        "name": "savedPrompt",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SavedPrompt",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "promptText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSavedPromptMutation_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSavedPromptMutation_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "df45158d2779d9b0b96480db55d7f113",
    "id": null,
    "metadata": {},
    "name": "CreateSavedPromptMutation_Mutation",
    "operationKind": "mutation",
    "text": "mutation CreateSavedPromptMutation_Mutation(\n  $input: CreateSavedPromptInput!\n) {\n  createSavedPrompt(input: $input) {\n    savedPrompt {\n      node {\n        id\n        name\n        promptText\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8beeb296e3f16abf95e9bdd5fd06f9e2";

export default node;
